import { Link } from "react-router";

import styles from "./not-found.module.scss";

export function NotFound() {
  return (
    <div className={styles.page}>
      <div className={styles.title}>Page not found</div>
      <div className={styles.description}>
        The page you're looking for doesn't exist or has been moved.
      </div>
      <Link to="/today" className={styles.link}>
        Go to today
      </Link>
    </div>
  );
}
